import { FC } from "react";
import { useAppSelector } from "../store";
import { StateToBadge } from "../ui/layout/molecules/Badge/StateToBadge";

export const FeedStatusBadge: FC = () => {
  const { list, loading, feedIsTriggering, status } = useAppSelector(
    (state) => state.feed,
  );
  const { productsCount, imagesCount } = useAppSelector(
    (state) => state.products.catalogDetails,
  );

  const isFeedEmpty = list.length === 0;

  const isImportSuccessful = productsCount > 0 && imagesCount > 0;
  const warningsCount = list[0] ? list[0].warningsCount : undefined;

  if (feedIsTriggering || loading || status === "idle") {
    return StateToBadge(feedIsTriggering ? "in progress" : "fetching");
  }

  if (isFeedEmpty)
    return StateToBadge(productsCount || imagesCount ? "noHistory" : "noFeed");

  if (isImportSuccessful) {
    if (!warningsCount) return StateToBadge("successful");
    else
      return StateToBadge(
        "warning",
        `${warningsCount} warning${warningsCount > 1 ? "s" : ""}`,
      );
  } else return StateToBadge("failed");
};
